import React from "react";
import RegleCard from "./RegleCard";
import { humanize } from "./humanize";

const ChampSection = ({ categorie, champKey, champ }) => {
  const id = `regle-${categorie}-${champKey}`;
  const total = champ.regles?.length || 0;

  return (
    <article
      id={id}
      className={`regles-calcul__champ regles-calcul__champ--${categorie}`}
      data-categorie={categorie}
      data-champ={champKey}
    >
      <header className="regles-calcul__champ-header">
        <div>
          <h3 className="regles-calcul__champ-title">{humanize(champKey)}</h3>
          <div className="regles-calcul__champ-subtitle">
            Champ calculé : <code>{champ.champ}</code>
          </div>
        </div>
        <span className="badge badge-secondary regles-calcul__champ-badge">
          {total} règle{total > 1 ? "s" : ""}
        </span>
      </header>

      <div className="regles-calcul__regles">
        {total === 0 ? (
          <p className="text-muted font-italic">Aucune règle définie.</p>
        ) : (
          champ.regles.map((regle, i) => (
            <RegleCard key={i} regle={regle} index={i} total={total} />
          ))
        )}
      </div>
    </article>
  );
};

export default ChampSection;
